import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import axios from './plugins/axios';
import Clipboard from 'v-clipboard';
import VueKindergarten from 'vue-kindergarten';
import child from './child';

require('./plugins/apexcharts');
require('./plugins/vee-validate');
require('./plugins/toasted');

Vue.use(Clipboard);

Vue.use(VueKindergarten, {
  child
})

store.dispatch('authUser').then(() => {
  Vue.component('default-layout', () => import('./layouts/DefaultLayout.vue'))
  Vue.component('map-layout', () => import('./layouts/MapLayout.vue'))
  Vue.component('admin-layout', () => import('./layouts/AdminLayout.vue'))

  Vue.prototype.$eventBus = new Vue()
  Vue.prototype.$axios = axios
  Vue.prototype.$axios.interceptors.request.use(
    (config) => {
      Vue.prototype.$eventBus.$emit('loading', true)
      return config
    },
    (error) => {
      Vue.prototype.$eventBus.$emit('loading', false)
      return Promise.reject(error)
    }
  )

  Vue.prototype.$axios.interceptors.response.use(
    (response) => {
      Vue.prototype.$eventBus.$emit('loading', false)
      return response
    },
    (error) => {
      Vue.prototype.$eventBus.$emit('loading', false)
      return Promise.reject(error)
    },
  )

  new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
  }).$mount('#app')
});

